import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';

export const IOSAppHeader = () => {
  return (
    <FullWidthContainer>
      {/* Page header is handled by the ios app */}
      <div className="hidden">
        <div className="w-full" id="page-header-title" />
        <div id="page-header-title-breadcrumb" />
      </div>
    </FullWidthContainer>
  );
};
